import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { showLoading, hideLoading } from '../store/loaderSlice';
import { setNotices } from '../store/noticeSlice';
import { setAlbums } from '../store/photoGallerySlice';
import { setVideos } from '../store/videoGallerySlice';

const TIMEOUT = 5000;

export function useFetchNotices() {
  const dispatch = useDispatch();
  const loaded = useSelector((s) => s.notices.loaded);

  useEffect(() => {
    if (loaded) return;
    dispatch(showLoading());
    axios.get(process.env.REACT_APP_NOTICE_API, { timeout: TIMEOUT })
      .then((r) => dispatch(setNotices(r.data || [])))
      .catch(() => dispatch(setNotices([])))
      .finally(() => dispatch(hideLoading()));
  }, [loaded, dispatch]);
}

export function useFetchPhotoGallery() {
  const dispatch = useDispatch();
  const loaded = useSelector((s) => s.photoGallery.loaded);

  useEffect(() => {
    if (loaded) return;
    dispatch(showLoading());
    axios.get(process.env.REACT_APP_GALLERY_API, { timeout: TIMEOUT })
      .then((r) => dispatch(setAlbums(r.data || [])))
      .catch(() => dispatch(setAlbums([])))
      .finally(() => dispatch(hideLoading()));
  }, [loaded, dispatch]);
}

export function useFetchVideoGallery() {
  const dispatch = useDispatch();
  const loaded = useSelector((s) => s.videoGallery.loaded);

  useEffect(() => {
    if (loaded) return;
    dispatch(showLoading());
    axios.get(process.env.REACT_APP_VIDEO_GALLERY_API, { timeout: TIMEOUT })
      .then((r) => dispatch(setVideos(r.data || [])))
      .catch(() => dispatch(setVideos([])))
      .finally(() => dispatch(hideLoading()));
  }, [loaded, dispatch]);
}

export function useHomeInit() {
  const dispatch = useDispatch();
  const [openPopup, setOpenPopup] = useState(false);
  const [popupData, setPopupData] = useState([]);

  useFetchNotices();
  useFetchPhotoGallery();
  useFetchVideoGallery();

  useEffect(() => {
    axios.get(process.env.REACT_APP_POPUP_API, { timeout: TIMEOUT })
      .then((r) => {
        if (r.data && r.data.length > 0) {
          setPopupData(r.data);
          setOpenPopup(true);
        }
      })
      .catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { openPopup, popupData, closePopup: () => setOpenPopup(false) };
}
